import { createApp } from 'vue'
import FormInputTextField from './FormInputTextField.vue'

const el = '.kb-component--form-input-text-field'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM && DOM.length) {
        DOM.forEach((FormInputTextFieldDOM) => {
            const props = {
                type: FormInputTextFieldDOM.dataset.type,
                tooltipText: FormInputTextFieldDOM.dataset.tooltiptext,
                errorMessageLabel:
                    FormInputTextFieldDOM.dataset.errormessagelabel,
                helpMessageLabel:
                    FormInputTextFieldDOM.dataset.helpmessagelabel,
                placeholder: FormInputTextFieldDOM.dataset.placeholder,
                label: FormInputTextFieldDOM.dataset.label,
                isRequired: !!(
                    FormInputTextFieldDOM.dataset.isrequired === 'true'
                ),
                fieldName: FormInputTextFieldDOM.dataset.fieldname
            }
            const component = createApp(FormInputTextField, props).use(Store)
            component.mount(FormInputTextFieldDOM)
        })
    }
}
